module.exports = __webpack_public_path__ + "img/lg_ring_y_l_0_null.ad16d73f.png";